import * as React from 'react';

import { GeneralInfoSectionRow } from '../../../components/GeneralInfoSectionRow';
import { ResizableWrapper } from '../../../components/ResizableWrapper';
import { DescriptionContainer } from '../DescriptionContainer';
import { KPAdvantagesContainer } from '../KPAdvantagesContainer';
import { KPNameContainer } from '../KPNameContainer';

export const ResizableContainer: React.FC = () => {
  return (
    <ResizableWrapper>
      <GeneralInfoSectionRow>
        <KPNameContainer />
        <KPAdvantagesContainer />
      </GeneralInfoSectionRow>
      <DescriptionContainer />
    </ResizableWrapper>
  );
};
